import axios from 'axios';
import {
    GET_PAYMENT_MODES,
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_PAYMENT_MODES, options);
    },
};
